// Library
import { createSlice } from "@reduxjs/toolkit";

export const filterSlice = createSlice({
    name: "filter",
    initialState: {
        year: new Date().getFullYear(),
    },
    reducers: {
        updateYear: (state, action) => {
            // console.log(action.payload);
            state.year = action.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const { updateYear } = filterSlice.actions;
export default filterSlice.reducer;